import React from 'react';
import { Modal } from 'baseui/modal';
import { useReportQAContext } from '../../../context';
import ConfigModalContent from './ConfigModalContent';
import ReportsModalContent from './ReportsModalContent';
import ResultsModalContent from './ResultsModalContent';
const RunQAModal = () => {
  const [, mutate, query] = useReportQAContext();
  const {
    content,
    open
  } = query(state => state.modal);
  return <Modal closeable isOpen={open} onClose={() => mutate(state => ({
    ...state,
    modal: {
      ...state.modal,
      open: false
    }
  }))} overrides={{
    Dialog: {
      style: {
        width: '60vw',
        overflow: 'hidden'
      }
    }
  }}>
      {content === 'config' && <ConfigModalContent />}
      {content === 'reports' && <ReportsModalContent />}
      {content === 'results' && <ResultsModalContent />}
    </Modal>;
};
export default RunQAModal;